import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c2c4394"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "meeting-menu-container" }
const _hoisted_2 = { class: "meeting-menu-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Google Meet Integration", -1))
const _hoisted_4 = { class: "meeting-menu-content" }
const _hoisted_5 = { class: "section" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Authentication", -1))
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "client-id" }, "Client ID", -1))
const _hoisted_9 = {
  key: 0,
  class: "warning-box"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "⚠️ Account Mismatch Warning:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "To join meetings created with your @ituri.ai account, you need to:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ol", null, [
  /*#__PURE__*/_createElementVNode("li", null, "Click \"Logout\" above"),
  /*#__PURE__*/_createElementVNode("li", null, "Click \"Login with Google\" again"),
  /*#__PURE__*/_createElementVNode("li", null, "Select your @ituri.ai account when prompted")
], -1))
const _hoisted_13 = { class: "section" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Meeting Setup", -1))
const _hoisted_15 = { class: "status-indicators" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "meeting-code" }, "Meeting Code", -1))
const _hoisted_18 = { class: "meeting-code-input-group" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 0,
  class: "form-group"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Meeting Link", -1))
const _hoisted_22 = { class: "meeting-link" }
const _hoisted_23 = ["href"]
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = { for: "video-stream" }
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = { class: "join-status-container" }
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "session-status" }
const _hoisted_30 = {
  key: 1,
  class: "help-text"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Join Meeting", -1))
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { key: 2 }
const _hoisted_35 = { key: 3 }
const _hoisted_36 = { key: 4 }
const _hoisted_37 = { class: "section" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Meeting Management", -1))
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["disabled"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = ["disabled"]
const _hoisted_43 = { class: "section audio-section" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Audio Stream Processing", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Real-time audio capture and server streaming")
], -1))
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "server-url" }, "Server WebSocket URL:", -1))
const _hoisted_48 = { class: "button-group" }
const _hoisted_49 = ["disabled"]
const _hoisted_50 = ["disabled"]
const _hoisted_51 = { class: "status" }
const _hoisted_52 = /*#__PURE__*/_createStaticVNode("<div class=\"info-box\" data-v-1c2c4394><h4 data-v-1c2c4394>Audio Processing Info:</h4><ul data-v-1c2c4394><li data-v-1c2c4394>Audio streams are automatically captured when you join a meeting</li><li data-v-1c2c4394>Real-time audio data is processed using Web Audio API</li><li data-v-1c2c4394>Audio data is sent to server via WebSocket in base64 format</li><li data-v-1c2c4394>Each audio chunk includes: streamId, timestamp, sampleRate, audio data, and participant metadata</li><li data-v-1c2c4394>Participant metadata includes: display name, user ID, and participant type (emails not available)</li><li data-v-1c2c4394>Audio levels are logged to console when significant audio is detected</li><li data-v-1c2c4394><strong data-v-1c2c4394>Note:</strong> You can start streaming before joining a meeting - it will begin sending audio once you join</li></ul></div>", 1)
const _hoisted_53 = { class: "section" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Invite Participants", -1))
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "participant-email" }, "Email Address:", -1))
const _hoisted_57 = ["disabled"]
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Default Participants", -1))
const _hoisted_59 = {
  key: 0,
  class: "info-box"
}
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Default participants will be automatically invited when creating a new meeting:")
], -1))
const _hoisted_61 = {
  key: 1,
  class: "info-box"
}
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("strong", null, "Default participants will be set after Google login")
], -1))
const _hoisted_63 = [
  _hoisted_62
]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Current Participants", -1))
const _hoisted_65 = ["innerHTML"]
const _hoisted_66 = {
  key: 0,
  class: "section"
}
const _hoisted_67 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Space Creation Result", -1))
const _hoisted_68 = { class: "result-box" }
const _hoisted_69 = /*#__PURE__*/_createStaticVNode("<div class=\"video-container\" style=\"display:none;\" data-v-1c2c4394><video id=\"video-1\" autoplay data-v-1c2c4394></video><video id=\"video-2\" autoplay data-v-1c2c4394></video><video id=\"video-3\" autoplay data-v-1c2c4394></video><video id=\"video-4\" autoplay data-v-1c2c4394></video><video id=\"video-5\" autoplay data-v-1c2c4394></video><video id=\"video-6\" autoplay data-v-1c2c4394></video><audio id=\"audio-1\" autoplay data-v-1c2c4394></audio><audio id=\"audio-2\" autoplay data-v-1c2c4394></audio><audio id=\"audio-3\" autoplay data-v-1c2c4394></audio></div>", 1)

import { ref, onMounted, onUnmounted, computed } from 'vue';
import { MeetMediaApiClientImpl } from '../meetings/meetmediaapiclient_impl';
import { MeetConnectionState } from '../types/enums';
import { MeetStreamTrack, MeetMediaClientRequiredConfiguration } from '../types/mediatypes';
import { MeetSessionStatus } from '../types/meetmediaapiclient';

// Calculate allocation size based on format

export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingMenu',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

function getBytesPerSample(format: string): number {
  switch (format) {
    case 'f32-planar':
    case 'f32-interleaved':
      return 4; // 32-bit float
    case 's16-planar':
    case 's16-interleaved':
      return 2; // 16-bit signed integer
    default:
      console.warn(`Unknown format: ${format}, assuming 4 bytes per sample`);
      return 4;
  }
}

const emit = __emit;

// Reactive data
const clientId = ref('1080270416070-3tukbhds4s7nvgroil32vhl6lt7s48le.apps.googleusercontent.com');
const meetingCode = ref('');
const videoStreamCount = ref(0);
const enableAudio = ref(true);
const sessionStatus = ref('New');
const serverUrl = ref('ws://localhost:8081');
const streamingStatus = ref('Not streaming');
const participantEmail = ref('');
const participantsList = ref('No participants yet');
const spaceResult = ref('');
const defaultParticipants = ref<string[]>([]);
const currentUserEmail = ref('');
const tokenResponse = ref<any>(null);
const client = ref<MeetMediaApiClientImpl | null>(null);
const isLeavingMeeting = ref(false);
const disconnectionComplete = ref(false);


// Computed properties for button states
const isLoggedIn = computed(() => !!tokenResponse.value?.access_token && !!currentUserEmail.value);
const hasMeetingCode = computed(() => !!meetingCode.value?.trim());
const canCreateSpace = computed(() => isLoggedIn.value);
const canJoinMeeting = computed(() => isLoggedIn.value && hasMeetingCode.value && disconnectionComplete.value);
const canInviteParticipant = computed(() => isLoggedIn.value && hasMeetingCode.value);
const canStartStreaming = computed(() => isLoggedIn.value && !isStreamingToServer.value);
const canStopStreaming = computed(() => isStreamingToServer.value);

// Global variables (adapted from script.ts)
const isStreamingToServer = ref(false);
let serverWebSocket: WebSocket | null = null;



// Map to track audio processing for each stream
const audioStreamProcessors = new Map<string, {
  audioContext?: AudioContext;
  audioProcessor?: ScriptProcessorNode;
  source?: MediaStreamAudioSourceNode;
  audioElement?: HTMLAudioElement;
}>();

const VIDEO_IDS = [1, 2, 3, 4, 5, 6];
const AUDIO_IDS = [1, 2, 3];

let availableVideoIds = [...VIDEO_IDS];
let availableAudioIds = [...AUDIO_IDS];
const trackIdToElementId = new Map<string, number>();

// Functions adapted from script.ts
async function handleSessionChange(status: MeetSessionStatus) {
  let statusString;
  switch (status.connectionState) {
    case MeetConnectionState.WAITING:
      statusString = 'WAITING';
      break;
    case MeetConnectionState.JOINED:
      statusString = 'JOINED';
      console.log('Session state changed to JOINED - checking participants...');
      
      // Reset disconnection state when joining
      disconnectionComplete.value = false;
      
      // Only apply layout if video is enabled
      if (client.value && videoStreamCount.value > 0) {
        const mediaLayout = client.value.createMediaLayout({ width: 500, height: 500 });
        const response = await client.value.applyLayout([{ mediaLayout }]);
        console.log(response);
      }

      // Start audio stream processing when joined
      startAudioStreamProcessing();
      
      // Refresh participant list when joined
      setTimeout(() => {
        if (client.value) {
          const joinedParticipants = client.value.participants.get();
          console.log('Participants when session joined:', joinedParticipants.length);
          console.log('Participants data when session joined:', joinedParticipants);
          displayParticipants();
        }
      }, 1000);
      break;
    case MeetConnectionState.DISCONNECTED:
      statusString = 'DISCONNECTED';
      console.log('Session state changed to DISCONNECTED');
      
      // Stop audio stream processing when disconnected
      stopAudioStreamProcessing();
      
      // Mark disconnection as complete after a short delay to ensure all cleanup is done
      setTimeout(() => {
        disconnectionComplete.value = true;
        console.log('Disconnection marked as complete - can rejoin now');
      }, 2000); // 2 second delay to ensure all cleanup is complete
      break;
    default:
      statusString = 'UNKNOWN';
      break;
  }
  sessionStatus.value = statusString;
}

function handleStreamChange(meetStreamTracks: MeetStreamTrack[]) {
  // We create local sets of ids so that we don't have to add back ids when
  // tracks are removed.
  const localAvailableVideoIds = new Set(VIDEO_IDS);
  const localAvailableAudioIds = new Set(AUDIO_IDS);
  
  meetStreamTracks.forEach((meetStreamTrack: MeetStreamTrack) => {
    if (meetStreamTrack.mediaStreamTrack.kind === 'video') {
      const elementId = trackIdToElementId.get(meetStreamTrack.mediaStreamTrack.id);
      if (elementId) {
        // If a track is already in the element then we remove it from the local
        // ids and continue.
        localAvailableVideoIds.delete(elementId);
        return;
      }
      
      // If this is a new track, then we create a MediaStream and add it to a
      // video element.
      const mediaStream = new MediaStream();
      mediaStream.addTrack(meetStreamTrack.mediaStreamTrack);

      // Update id collections. We do expect to run out of available ids, but
      // reassign to a valid id (1) in case we do.
      const videoId = availableVideoIds.pop() ?? 1;
      localAvailableVideoIds.delete(videoId);

      // Retrieve available video element and assign media stream to it.
      const videoIdString = `video-${videoId}`;
      const videoElement = document.getElementById(videoIdString) as HTMLVideoElement;
      if (videoElement) {
        videoElement.srcObject = mediaStream;
      }
      trackIdToElementId.set(meetStreamTrack.mediaStreamTrack.id, videoId);
    } else if (meetStreamTrack.mediaStreamTrack.kind === 'audio') {
      const elementId = trackIdToElementId.get(meetStreamTrack.mediaStreamTrack.id);
      if (elementId) {
        // If a track is already in the element then we remove it from the local
        // ids and continue.
        localAvailableAudioIds.delete(elementId);
        return;
      }

      // If this is a new track, then we create a MediaStream and add it to a
      // audio element.
      const mediaStream = new MediaStream();
      mediaStream.addTrack(meetStreamTrack.mediaStreamTrack);

      // Update id collections. We do expect to run out of available ids, but
      // reassign to a valid id (1) in case we do.
      const audioId = availableAudioIds.pop() ?? 1;
      localAvailableAudioIds.delete(audioId);

      // Retrieve available audio element and assign media stream to it.
      const audioIdString = `audio-${audioId}`;
      const audioElement = document.getElementById(audioIdString) as HTMLAudioElement;
      if (audioElement) {
        audioElement.srcObject = mediaStream;
      }
      trackIdToElementId.set(meetStreamTrack.mediaStreamTrack.id, audioId);

      // Automatically process new audio streams for real-time processing
      // Only process when session is JOINED to avoid processing during WAITING state
      console.log(`New audio stream detected: ${audioIdString} (session status: ${sessionStatus.value})`);
      if (sessionStatus.value === 'JOINED') {
      setTimeout(() => {
        if (audioElement && audioElement.srcObject) {
          processAudioStream(audioElement.srcObject as MediaStream, audioIdString);
        }
      }, 100); // Small delay to ensure the stream is properly set
      } else {
        console.log(`Skipping audio processing for ${audioIdString} - session not yet joined`);
      }
    }
  });

  // Set local set of tracks to top level available id collections.
  availableVideoIds = [...localAvailableVideoIds];
  availableAudioIds = [...localAvailableAudioIds];
}

async function createClient(): Promise<void> {
  console.log('=== createClient function called ===');
  
  if (!tokenResponse.value) {
    console.log('No token response in createClient');
    throw new Error('You must login before creating the client');
  }
  
  if (!meetingCode.value) {
    console.log('No meeting code in createClient');
    throw new Error('Please enter a meeting code or create a space first');
  }
  
  const authToken = tokenResponse.value.access_token;
  console.log('Auth token exists:', !!authToken);
  console.log('Auth token length:', authToken?.length);
  
  // Create the actual MeetMediaApiClientImpl
  const config: MeetMediaClientRequiredConfiguration = {
    meetingSpaceId: 'spaces/' + meetingCode.value,
    numberOfVideoStreams: videoStreamCount.value,
    enableAudioStreams: enableAudio.value,
    accessToken: authToken
  };
  
  console.log('=== Configuration Debug ===');
  console.log('videoStreamCount.value:', videoStreamCount.value);
  console.log('enableAudio.value:', enableAudio.value);
  console.log('config.numberOfVideoStreams:', config.numberOfVideoStreams);
  console.log('config.enableAudioStreams:', config.enableAudioStreams);
  console.log('=== End Configuration Debug ===');

  // Print all configuration parameters at runtime
  console.log('=== Google Meet API Configuration Parameters ===');
  console.log('meetingSpaceId:', config.meetingSpaceId);
  console.log('numberOfVideoStreams:', config.numberOfVideoStreams);
  console.log('enableAudioStreams:', config.enableAudioStreams);
  console.log('accessToken exists:', !!config.accessToken);
  console.log('accessToken length:', config.accessToken?.length);
  console.log('accessToken preview:', config.accessToken ? `${config.accessToken.substring(0, 20)}...` : 'undefined');
  console.log('=== End Configuration Parameters ===');

  try {
    console.log('About to create MeetMediaApiClientImpl...');
    client.value = new MeetMediaApiClientImpl(config);
    console.log('MeetMediaApiClientImpl created successfully');

    // Set up subscriptions
    console.log('Setting up subscriptions...');
    client.value.sessionStatus.subscribe(handleSessionChange);
    client.value.meetStreamTracks.subscribe(handleStreamChange);
    client.value.participants.subscribe(() => {
      console.log('Participants subscription triggered - updating display');
      displayParticipants();
    });
    
    // Initial participant check
    console.log('Initial participant check after client creation:');
    const initialParticipants = client.value.participants.get();
    console.log('Initial participants count:', initialParticipants.length);
    console.log('Initial participants data:', initialParticipants);

    console.log('Media API Client created successfully.');
  } catch (error) {
    console.error('Error creating Meet client:', error);
    console.error('Error stack:', error instanceof Error ? error.stack : 'No stack trace');
    throw new Error('Error creating Meet client: ' + error);
  }
}

async function joinMeeting() {
  console.log('=== joinMeeting function called ===');
  console.log('tokenResponse.value exists:', !!tokenResponse.value);
  console.log('meetingCode.value:', meetingCode.value);
  console.log('canJoinMeeting.value:', canJoinMeeting.value);
  
  // Validate prerequisites
  if (!tokenResponse.value) {
    console.log('No token response - showing alert');
    alert('You must login before joining a meeting');
    return;
  }

  if (!meetingCode.value || meetingCode.value.trim() === '') {
    console.log('No meeting code - showing alert');
    alert('Please enter a valid meeting code');
    return;
  }
  
  // Check if access token is still valid
  if (!tokenResponse.value?.access_token) {
    console.log('No access token - showing alert');
    alert('Access token is missing. Please login again.');
    return;
  }

  console.log('All prerequisites met, proceeding with join...');

  // Create client if it doesn't exist
  if (!client.value) {
    console.log('No client found. Creating client automatically...');
    try {
      await createClient();
      console.log('Client created successfully');
    } catch (error) {
      console.error('Failed to create client:', error);
      alert('Failed to create client: ' + error);
      return;
    }
  } else {
    console.log('Using existing client for join attempt');
  }

  // Ensure client exists after creation
  if (!client.value) {
    console.log('Client still null after creation attempt');
    alert('Failed to create client. Please try again.');
    return;
  }

  // Add debugging information
  console.log('Attempting to join meeting...');
  console.log('Meeting Space ID:', 'spaces/' + meetingCode.value);
  console.log('Access Token exists:', !!tokenResponse.value?.access_token);
  console.log('Access Token length:', tokenResponse.value?.access_token?.length);
  console.log('Video streams:', videoStreamCount.value);
  console.log('Audio enabled:', enableAudio.value);
  
  // Check current participants (informational only)
  const participants = client.value.participants.get();
  console.log('Current participants before joining:', participants.length);
  console.log('Participants data:', participants);
  
  // Also check if the participants subscription is working
  console.log('Client participants object:', client.value.participants);

  try {
    console.log('About to call client.joinMeeting()...');
    const result = await client.value.joinMeeting();
    console.log('Join meeting result:', result);
    
    // Check participants after joining
    setTimeout(() => {
      const participantsAfterJoin = client.value!.participants.get();
      console.log('Participants after joining:', participantsAfterJoin.length);
      console.log('Participants data after joining:', participantsAfterJoin);
      if (participantsAfterJoin.length === 0) {
        console.log('No other participants in the meeting yet. You can invite participants or wait for them to join.');
      } else {
        console.log('Found participants in the meeting after joining!');
        displayParticipants(); // Update the UI with the new participant data
      }
    }, 2000); // Increased delay to allow more time for participant list to update
    
  } catch (error: any) {
    console.error('Error joining meeting:', error);
    console.error('Error details:', {
      name: error?.name,
      message: error?.message,
      stack: error?.stack,
      cause: error?.cause
    });
    
    // Provide more specific error messages
    if (error?.message && error.message.includes('429')) {
      alert('Connection limit reached: Too many Media API connections for this meeting.\n\nThis usually happens when:\n1. You recently left the meeting and the connection hasn\'t been fully cleaned up yet\n2. Multiple instances are trying to connect to the same meeting\n\nPlease wait 30-60 seconds and try again, or try creating a new meeting.');
    } else if (error?.message && error.message.includes('Failed to fetch')) {
      alert('Network error: Unable to connect to Google Meet API. Please check:\n1. Your internet connection\n2. If the meeting code is valid\n3. If you have proper permissions for this meeting');
    } else if (error?.message && error.message.includes('403')) {
      alert('Permission denied (403): Unable to join the meeting.\n\nThis usually means:\n1. The meeting code is invalid or expired\n2. You don\'t have permission to join this meeting\n3. The meeting is full or has restricted access\n4. Your Google account doesn\'t have the required permissions\n\nTry:\n1. Creating a new meeting\n2. Checking the meeting code\n3. Using a different Google account');
    } else if (error?.message && error.message.includes('connectActiveConference')) {
      alert('Conference connection error: Unable to join the meeting. Please verify:\n1. The meeting code is correct\n2. The meeting is still active\n3. You have permission to join this meeting');
    } else {
      alert('Error joining meeting: ' + (error?.message || 'Unknown error'));
    }
    
    // Don't re-throw the error - it's already handled with the alert
    // Just return to let the UI handle the error state gracefully
    return;
  }
}

async function leaveMeeting() {
  console.log('=== leaveMeeting function called ===');
  
  if (isLeavingMeeting.value) {
    console.log('Already leaving meeting, ignoring duplicate request');
    return;
  }
  
  isLeavingMeeting.value = true;
  
  try {
    if (client.value) {
      console.log('Calling client.leaveMeeting()...');
      
      // Wait for the leave operation to complete (this waits for Google's server acknowledgment)
      await client.value.leaveMeeting();
      console.log('Successfully left meeting - server acknowledged leave request');
      
      // The session status will change to DISCONNECTED, which will trigger handleSessionChange
      // and set disconnectionComplete.value = true after cleanup
      
      // Clean up the client to force a new connection on next join
      console.log('Cleaning up client...');
      client.value = null;
      
      // Reset session status
      sessionStatus.value = 'New';
      
      // Stop audio processing
      stopAudioStreamProcessing();
      
      console.log('Meeting cleanup completed - waiting for disconnection to be marked complete');
    } else {
      console.log('No client to leave meeting with');
      // If no client, we can immediately mark disconnection as complete
      disconnectionComplete.value = true;
    }
  } catch (error) {
    console.error('Error leaving meeting:', error);
    // Even if there's an error, clean up the client
    client.value = null;
    sessionStatus.value = 'New';
    stopAudioStreamProcessing();
    
    // Mark disconnection as complete even on error
    disconnectionComplete.value = true;
  } finally {
    isLeavingMeeting.value = false;
  }
}

async function createSpace() {
  // Get the access token from your login flow
  const accessToken = tokenResponse.value?.access_token;
  if (!accessToken) {
    alert('You must log in first!');
    return;
  }

  try {
    const response = await fetch('https://meet.googleapis.com/v2/spaces', {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + accessToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({})
    });

    if (!response.ok) {
      const error = await response.json();
      alert('Error: ' + JSON.stringify(error));
      spaceResult.value = 'Error: ' + JSON.stringify(error, null, 2);
      return;
    }

    const space = await response.json();
    spaceResult.value = JSON.stringify(space, null, 2);
    
    if (space.meetingCode) {
      meetingCode.value = space.meetingCode;
      await inviteDefaultParticipants(space.meetingCode, accessToken);
    }
  } catch (error) {
    console.error('Error creating space:', error);
    alert('Error creating space: ' + error);
  }
}

async function inviteDefaultParticipants(meetingCode: string, accessToken: string): Promise<void> {
  if (defaultParticipants.value.length === 0) {
    console.log('No default participants set, skipping invitation');
    return;
  }

  console.log('Inviting default participants:', defaultParticipants.value);

  for (const email of defaultParticipants.value) {
    try {
      // Create calendar event with meeting link
      const response = await fetch('https://www.googleapis.com/calendar/v3/calendars/primary/events', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accessToken}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          summary: 'Google Meet Meeting',
          description: `Join the meeting: https://meet.google.com/${meetingCode}`,
          start: {
            dateTime: new Date().toISOString(),
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
          },
          end: {
            dateTime: new Date(Date.now() + 3600000).toISOString(),
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
          },
          attendees: [{ email }],
          conferenceData: {
            createRequest: {
              requestId: meetingCode,
              conferenceSolutionKey: { type: 'hangoutsMeet' }
            }
          }
        })
      });

      if (!response.ok) {
        const error = await response.json();
        console.error(`Error inviting ${email}:`, error);
        continue;
      }

      const event = await response.json();
      console.log(`Invitation sent to ${email}:`, event);

    } catch (error) {
      console.error(`Error inviting ${email}:`, error);
    }
  }

  // Show success message
  spaceResult.value += '\n\nDefault participants invited:\n' + defaultParticipants.value.join('\n');
}

async function inviteParticipant() {
  if (!participantEmail.value) {
    alert('Please enter an email address');
    return;
  }

  if (!meetingCode.value) {
    alert('Please enter a meeting code first');
    return;
  }

  const accessToken = tokenResponse.value?.access_token;
  if (!accessToken) {
    alert('You must log in first!');
    return;
  }

  try {
    // Create calendar event with meeting link
    const response = await fetch('https://www.googleapis.com/calendar/v3/calendars/primary/events', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        summary: 'Google Meet Meeting',
        description: `Join the meeting: https://meet.google.com/${meetingCode.value}`,
        start: {
          dateTime: new Date().toISOString(),
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        },
        end: {
          dateTime: new Date(Date.now() + 3600000).toISOString(),
          timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
        },
        attendees: [{ email: participantEmail.value }],
        conferenceData: {
          createRequest: {
            requestId: meetingCode.value,
            conferenceSolutionKey: { type: 'hangoutsMeet' }
          }
        }
      })
    });

    if (!response.ok) {
      const error = await response.json();
      alert('Error inviting participant: ' + JSON.stringify(error));
      return;
    }

    const event = await response.json();
    console.log(`Invitation sent to ${participantEmail.value}!`);
    console.log('Calendar event created:', event);
    participantEmail.value = '';

  } catch (error) {
    console.error('Error inviting participant:', error);
    alert('Error inviting participant: ' + error);
  }
}

async function testApiConnectivity() {
  console.log('Testing API connectivity...');
  if (!tokenResponse.value?.access_token) {
    alert('No access token available. Please login first.');
    return;
  }
  
  console.log('Access token length:', tokenResponse.value.access_token.length);
  console.log('Access token preview:', tokenResponse.value.access_token.substring(0, 20) + '...');
  
  try {
    // Test Google APIs connectivity (this endpoint supports CORS)
    // Note: We skip basic internet connectivity test to avoid CORS issues when running locally
    console.log('Testing Google APIs connectivity...');
    const googleTest = await fetch('https://www.googleapis.com/discovery/v1/apis', { method: 'GET' });
    console.log('Google APIs test status:', googleTest.status);
    
    if (!googleTest.ok) {
      alert('Google APIs connectivity test failed. This might be a firewall or network issue.');
      return;
    }
    
    console.log('Google APIs connectivity test successful');
    
    // Test Meet API specifically
    console.log('Testing Meet API connectivity...');
    
    // Try different Meet API endpoints to find the correct one
    // Based on Google's implementation, the correct endpoint is v2beta
    const meetApiEndpoints = [
      'https://meet.googleapis.com/v2beta/spaces',
      'https://meet.googleapis.com/v2/spaces',
      'https://meet.googleapis.com/v1/spaces',
      'https://meet.googleapis.com/v2beta1/spaces',
      'https://meet.googleapis.com/v1beta1/spaces'
    ];
    
    let response = null;
    let workingEndpoint = null;
    let spacesCreationResult = 'Not tested';
    
    for (const endpoint of meetApiEndpoints) {
      try {
        console.log(`Trying endpoint: ${endpoint}`);
        response = await fetch(endpoint, {
          method: 'GET',
                  headers: {
          'Authorization': `Bearer ${tokenResponse.value.access_token}`,
          'Content-Type': 'application/json'
        }
        });
        
        console.log(`Endpoint ${endpoint} status: ${response.status}`);
        
        if (response.status !== 404) {
          workingEndpoint = endpoint;
          break;
        }
              } catch (error: any) {
          console.log(`Endpoint ${endpoint} failed:`, error?.message || 'Unknown error');
        }
    }
    
    if (!workingEndpoint) {
      console.log('All GET endpoints failed, but continuing with POST test...');
    } else {
      console.log(`Using working endpoint: ${workingEndpoint}`);
    }
    
    console.log(`Using working endpoint: ${workingEndpoint}`);
    
    if (!response) {
      alert('No valid response received from any Meet API endpoint');
      return;
    }
    
    // Also test the spaces creation endpoint (different from the media API)
    console.log('Testing spaces creation endpoint...');
    try {
      const spacesResponse = await fetch('https://meet.googleapis.com/v2/spaces', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${tokenResponse.value.access_token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({})
      });
      
      console.log('Spaces creation test status:', spacesResponse.status);
      if (spacesResponse.ok) {
        console.log('Spaces creation endpoint works - this suggests the issue is with the media API specifically');
        spacesCreationResult = '✅ Working';
      } else {
        console.log('Spaces creation endpoint also fails - this suggests a broader API access issue');
        spacesCreationResult = `❌ Failed (${spacesResponse.status})`;
      }
    } catch (error: any) {
      console.log('Spaces creation test failed:', error?.message);
      spacesCreationResult = `❌ Error: ${error?.message}`;
    }
    
    // Final summary based on actual results
    console.log('=== API Connectivity Test Summary ===');
    console.log('Google APIs: ✅ Working (status: 200)');
    console.log(`Meet API GET endpoints: ${workingEndpoint ? '✅ Working' : '❌ All failed (404)'}`);
    if (workingEndpoint) {
      console.log(`Working endpoint: ${workingEndpoint}`);
    }
    console.log(`Spaces creation POST: ${spacesCreationResult}`);
    console.log('=== End Summary ===');
    
    if (!workingEndpoint) {
      alert('API Connectivity Test Results:\n\n✅ Google APIs: Working\n❌ Meet API GET endpoints: All failed (404)\n\nThis suggests:\n1. Your account may not have access to the Google Meet API\n2. The API may not be enabled for your account\n3. The original developer needs to verify your access permissions\n\nTry the spaces creation test above to see if POST endpoints work.');
      return;
    }
    
    console.log('Meet API test response status:', response.status);
    console.log('Meet API test response headers:', Object.fromEntries(response.headers.entries()));
    
    if (response.ok) {
      console.log('Meet API connectivity test successful');
    } else {
      const errorText = await response.text();
      console.error('Meet API test failed - Status:', response.status);
      console.error('Meet API test failed - Response:', errorText);
      
      let errorMessage = `Meet API test failed (Status: ${response.status})`;
      
      if (response.status === 401) {
        errorMessage += '\n\nThis indicates an authentication issue. Please:\n1. Log out and log back in\n2. Check if your Google account has access to Google Meet API';
      } else if (response.status === 403) {
        errorMessage += '\n\nThis indicates a permissions issue. Please:\n1. Check if your Google Cloud project has the Meet API enabled\n2. Verify the OAuth scopes include meetings permissions';
      } else if (response.status === 404) {
        errorMessage += '\n\nThis indicates the API endpoint is not found. Please check the API URL.';
      }
      
      alert(errorMessage);
    }
  } catch (error: any) {
    console.error('API connectivity test error:', error);
    console.error('Error details:', {
      name: error?.name,
      message: error?.message,
      stack: error?.stack,
      cause: error?.cause
    });
    
    let errorMessage = 'API connectivity test error: ' + (error?.message || 'Unknown error');
    
    if (error?.message?.includes('Failed to fetch')) {
      errorMessage += '\n\nThis usually indicates:\n1. Network connectivity issues\n2. Firewall blocking the request\n3. CORS issues (if running locally)\n4. DNS resolution problems\n\nNote: CORS errors are common when running locally. The test will continue with the Google APIs test.';
    }
    
    alert(errorMessage);
  }
}



function refreshParticipants() {
  console.log('Manually refreshing participants...');
  if (!client.value) {
    console.log('No client available for refresh');
    return;
  }
  
  const participants = client.value.participants.get();
  console.log('Refreshed participants count:', participants.length);
  console.log('Refreshed participants data:', participants);
  displayParticipants();
}

function refreshParticipantMapping() {
  console.log('Manually refreshing participant mapping...');
  if (!client.value) {
    console.log('No client available for refresh');
    return;
  }
  
  // Get all audio elements and try to map them
  const audioElements = document.querySelectorAll('audio[id^="audio-"]');
  console.log(`Found ${audioElements.length} audio elements to map`);
  
  for (let i = 0; i < audioElements.length; i++) {
    const audioElement = audioElements[i] as HTMLAudioElement;
    if (audioElement.srcObject) {
      const streamId = audioElement.id;
      const participantInfo = getParticipantForAudioStream(streamId);
      if (participantInfo) {
        console.log(`Successfully mapped ${streamId} to participant: ${participantInfo.displayName}`);
      } else {
        console.log(`Could not map ${streamId} to any participant`);
      }
    }
  }
}

function displayParticipants() {
  if (!client.value) {
    participantsList.value = '<div class="participant-item">No client connected</div>';
    return;
  }

  const participants = client.value.participants.get();
  console.log('Displaying participants:', participants);
  
  if (participants.length === 0) {
    participantsList.value = '<div class="participant-item">No participants in meeting (you may be the only one)</div>';
    return;
  }

  const participantHtml = participants.map((participant: any) => {
    const displayName = participant.participant.signedInUser?.displayName ||
      participant.participant.anonymousUser?.displayName ||
      participant.participant.phoneUser?.displayName ||
      'Unknown';

    const type = participant.participant.signedInUser ? 'Signed In' :
      participant.participant.anonymousUser ? 'Anonymous' :
        participant.participant.phoneUser ? 'Phone' : 'Unknown';

    const userId = participant.participant.signedInUser?.user || 'No user ID';

    return `<div class="participant-item">
      <strong>${displayName}</strong> (${type})
      <br><small>${userId}</small>
    </div>`;
  }).join('');

  participantsList.value = participantHtml;
  

}

// Audio processing functions
function startAudioStreamProcessing() {
  console.log('Starting audio stream processing...');

  // Get all audio elements that have streams
  const audioElements = document.querySelectorAll('audio[id^="audio-"]');

  if (audioElements.length === 0) {
    console.log('No audio elements found, waiting for streams...');
    return;
  }

  // Process each audio element
  for (let i = 0; i < audioElements.length; i++) {
    const audioElement = audioElements[i] as HTMLAudioElement;
    if (audioElement.srcObject) {
      console.log(`Processing audio stream ${i + 1}`);
      processAudioStream(audioElement.srcObject as MediaStream, `audio-${i + 1}`);
    }
  }
  
  // Update streaming status if we're connected to server
  if (isStreamingToServer.value && serverWebSocket && serverWebSocket.readyState === WebSocket.OPEN) {
    streamingStatus.value = 'Streaming audio to server';
  }
}

function processAudioStream(mediaStream: MediaStream, streamId: string) {
  try {
    // Check if we already have an audio context for this stream
    if (audioStreamProcessors.has(streamId)) {
      console.log(`Audio processing already active for ${streamId}, skipping...`);
      return;
    }

    // Get the audio element that's actually playing the audio
    const audioElement = document.getElementById(streamId) as HTMLAudioElement;
    if (!audioElement) {
      console.log(`Audio element ${streamId} not found`);
      return;
    }

    // WORKING APPROACH: Use ScriptProcessorNode like the Google sample
    console.log(`[AUDIO_SETUP] Setting up ScriptProcessorNode for ${streamId}`);
    
    const audioTracks = mediaStream.getAudioTracks();
    if (audioTracks.length === 0) {
      console.log(`[AUDIO_SETUP] No audio tracks found in ${streamId}`);
      return;
    }

    const audioTrack = audioTracks[0];
    console.log(`[AUDIO_SETUP] ${streamId} audio track:`, {
      id: audioTrack.id,
      enabled: audioTrack.enabled,
      muted: audioTrack.muted,
      readyState: audioTrack.readyState,
      kind: audioTrack.kind
    });

    // Create AudioContext for processing
    const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    console.log(`[AUDIO_DEBUG] ${streamId}: AudioContext sampleRate=${audioContext.sampleRate}Hz`);
    
    // Create media source from stream
    const source = audioContext.createMediaStreamSource(mediaStream);
    
    // Check the actual number of channels in the audio track
    const streamAudioTracks = mediaStream.getAudioTracks();
    const streamAudioTrack = streamAudioTracks[0];
    console.log(`[CHANNEL_DEBUG] ${streamId}: Audio track channels:`, {
      id: streamAudioTrack.id,
      enabled: streamAudioTrack.enabled,
      muted: streamAudioTrack.muted,
      readyState: streamAudioTrack.readyState,
      kind: streamAudioTrack.kind
    });
    
    // Create script processor for real-time audio processing
    // Use the actual number of channels from the source
    const inputChannels = source.channelCount;
    const outputChannels = 1; // Always output mono for WAV file
    console.log(`[CHANNEL_DEBUG] ${streamId}: Creating ScriptProcessor with inputChannels=${inputChannels}, outputChannels=${outputChannels}`);
    const audioProcessor = audioContext.createScriptProcessor(4096, inputChannels, outputChannels);
    
    // Log the first audio processing event to see actual channel counts
    let firstProcess = true;
    
    // Process audio data in real-time
    audioProcessor.onaudioprocess = (event) => {
      const inputBuffer = event.inputBuffer;
      const outputBuffer = event.outputBuffer;
      

      
          // Log the first audio processing event to see actual channel counts
    if (firstProcess) {
      console.log(`[CHANNEL_DEBUG] ${streamId}: FIRST PROCESS - inputChannels=${inputBuffer.numberOfChannels}, outputChannels=${outputBuffer.numberOfChannels}, samples=${inputBuffer.length}, sampleRate=${audioContext.sampleRate}Hz`);
      console.log(`[CHANNEL_DEBUG] ${streamId}: Expected buffer duration: ${(inputBuffer.length / audioContext.sampleRate * 1000).toFixed(2)}ms`);
      firstProcess = false;
    }
      
      // Get output data (always mono)
      const outputData = outputBuffer.getChannelData(0);
      
      // Handle multiple input channels by mixing them to mono
      if (inputBuffer.numberOfChannels === 1) {
        // Mono input - direct copy
        const inputData = inputBuffer.getChannelData(0);
        for (let i = 0; i < inputData.length; i++) {
          outputData[i] = inputData[i];
        }
      } else if (inputBuffer.numberOfChannels === 2) {
        // Stereo input - mix to mono
        const leftChannel = inputBuffer.getChannelData(0);
        const rightChannel = inputBuffer.getChannelData(1);
        for (let i = 0; i < leftChannel.length; i++) {
          outputData[i] = (leftChannel[i] + rightChannel[i]) / 2;
        }
      } else {
        // Multiple channels - mix all channels
        for (let i = 0; i < outputData.length; i++) {
          let sum = 0;
          for (let ch = 0; ch < inputBuffer.numberOfChannels; ch++) {
            sum += inputBuffer.getChannelData(ch)[i];
          }
          outputData[i] = sum / inputBuffer.numberOfChannels;
        }
      }
      
      // Use the output data for processing (it's now mono)
      const inputData = outputData;
      
          
      
      // Calculate RMS audio level
      const audioLevel = calculateAudioLevel(inputData);
      
      // Check for non-zero audio data
      let hasNonZeroData = false;
      for (let i = 0; i < inputData.length; i++) {
        if (inputData[i] !== 0) {
          hasNonZeroData = true;
          break;
        }
      }
      
                // Send audio data to server if streaming
      if (isStreamingToServer.value && serverWebSocket && serverWebSocket.readyState === WebSocket.OPEN) {
        // Log sample rate and buffer info occasionally
        if (Math.random() < 0.01) { // Log ~1% of the time
          console.log(`[AUDIO_PROCESSOR] ${streamId} - Sample rate: ${audioContext.sampleRate}Hz, buffer length: ${inputData.length}, expected duration: ${(inputData.length / audioContext.sampleRate * 1000).toFixed(2)}ms`);
        }
        sendAudioDataToServer(inputData, streamId, audioContext.sampleRate);
      }
      
      // Log audio activity (but limit frequency to avoid spam)
      if (hasNonZeroData && audioLevel > 0.01 && Math.random() < 0.05) { // Log ~5% of audio detections
        console.log(`[AUDIO_PROCESSOR] ${streamId} - Audio detected: level=${audioLevel.toFixed(6)}, samples=${inputData.length}`);
      }
    };
    
    // Connect the audio processing chain
    source.connect(audioProcessor);
    
    // Create a silent gain node to trigger processing without audio output
    const silentGain = audioContext.createGain();
    silentGain.gain.setValueAtTime(0, audioContext.currentTime); // Set volume to 0
    audioProcessor.connect(silentGain);
    silentGain.connect(audioContext.destination); // Connect to destination but silent
    
    console.log(`[AUDIO_SETUP] ScriptProcessorNode processing started for ${streamId}`);
    
    // Store the processor for cleanup
    audioStreamProcessors.set(streamId, {
      audioContext,
      audioProcessor,
      source,
      audioElement
    });
    
  } catch (error) {
    console.error('Error processing audio stream:', error);
  }
}

function calculateAudioLevel(audioData: Float32Array): number {
  // Calculate RMS (Root Mean Square) which is more accurate for audio levels
  let sum = 0;
  for (let i = 0; i < audioData.length; i++) {
    sum += audioData[i] * audioData[i];
  }
  return Math.sqrt(sum / audioData.length);
}

function getParticipantForAudioStream(streamId: string): any {
  if (!client.value) {
    return null;
  }

  // Get the specific audio element for this stream ID
  const audioElement = document.getElementById(streamId) as HTMLAudioElement;
  if (!audioElement || !audioElement.srcObject) {
    return null;
  }

  const mediaStream = audioElement.srcObject as MediaStream;
  const audioTracks = mediaStream.getAudioTracks();
  if (audioTracks.length === 0) {
    return null;
  }

  // Get the track ID from the audio element
  const trackId = audioTracks[0].id;

  // Get media entries and find the one with matching audio track
  const mediaEntries = client.value.mediaEntries.get();
  
  // Only log participant lookup attempts occasionally to reduce spam
  if (Math.random() < 0.1) { // Log ~10% of the time
    console.log(`Looking for participant for stream ${streamId} with track ID: ${trackId}`);
    console.log('Available media entries:', mediaEntries.length);
  }

  // Find the media entry that has this audio track
  for (const mediaEntry of mediaEntries) {
    const audioTrack = mediaEntry.audioMeetStreamTrack.get();
    if (audioTrack && audioTrack.mediaStreamTrack.id === trackId) {
      // Found the match! Get participant info
      const participant = mediaEntry.participant.get();
      if (participant) {
        const participantInfo = {
          id: participant.participant.signedInUser?.user || 
              participant.participant.anonymousUser?.displayName || 
              participant.participant.phoneUser?.displayName || 
              'Unknown',
          displayName: participant.participant.signedInUser?.displayName ||
                      participant.participant.anonymousUser?.displayName ||
                      participant.participant.phoneUser?.displayName ||
                      'Unknown',
          userId: participant.participant.signedInUser?.user || null,
          type: participant.participant.signedInUser ? 'Signed In' :
                participant.participant.anonymousUser ? 'Anonymous' :
                participant.participant.phoneUser ? 'Phone' : 'Unknown'
        };
        
        // Only log successful mappings occasionally to reduce spam
        if (Math.random() < 0.1) { // Log ~10% of the time
          console.log(`Mapped stream ${streamId} to participant:`, participantInfo);
        }
        return participantInfo;
      }
    }
  }

  // Only log "no participant found" occasionally to reduce spam
  if (Math.random() < 0.1) { // Log ~10% of the time
    console.log(`No participant found for stream ${streamId}`);
  }
  return null;
}

function sendAudioDataToServer(audioData: Float32Array, streamId: string, sampleRate: number) {
  try {
    // Convert Float32Array to s16le for transmission (50% smaller)
    const s16leBuffer = new ArrayBuffer(audioData.length * 2);
    const view = new DataView(s16leBuffer);
    let clippingDetected = false;
    let sum = 0;
    let sumSquares = 0;
    
    for (let i = 0; i < audioData.length; i++) {
      // Convert float32 (-1.0 to 1.0) to int16 (-32768 to 32767)
      const s16Value = Math.max(-32768, Math.min(32767, Math.round(audioData[i] * 32767)));
      view.setInt16(i * 2, s16Value, true); // little-endian
      
      // Check for clipping
      if (audioData[i] > 1.0 || audioData[i] < -1.0) {
        clippingDetected = true;
      }
      
      // Calculate audio level (average absolute value)
      sum += Math.abs(audioData[i]);
      
      // Calculate RMS (root mean square)
      sumSquares += audioData[i] * audioData[i];
    }

    const s16leAudio = btoa(String.fromCharCode(...new Uint8Array(s16leBuffer)));
    
    // Calculate final metrics
    const avgAudioLevel = sum / audioData.length;
    const rms = Math.sqrt(sumSquares / audioData.length);

    // Get participant information for this audio stream
    const participantInfo = getParticipantForAudioStream(streamId);

    // Send to server
    const message = {
      type: 'audio_data',
      streamId: streamId,
      timestamp: Date.now(),
      sampleRate: sampleRate,
      data: s16leAudio,
      audioLevel: avgAudioLevel,
      rms: rms,
      clippingDetected: clippingDetected,
      sampleCount: audioData.length,
      // Add participant metadata if available
      participant: participantInfo ? {
        id: participantInfo.id,
        displayName: participantInfo.displayName,
        userId: participantInfo.userId,
        type: participantInfo.type
      } : null
    };

    // Send the message to server (only once)
    serverWebSocket?.send(JSON.stringify(message));

  } catch (error) {
    console.error('Error sending audio data to server:', error);
  }
}

function startStreamingToServer() {
  try {
    serverWebSocket = new WebSocket(serverUrl.value);

    serverWebSocket.onopen = () => {
      console.log('Connected to audio server');
      isStreamingToServer.value = true;
      streamingStatus.value = 'Connected to server';
      
      // After connecting, check if we have audio streams to process
      // If we're in a meeting and have audio streams, start processing them
      if (sessionStatus.value === 'JOINED') {
        console.log('Meeting is joined, checking for audio streams to process...');
        startAudioStreamProcessing();
      } else {
        console.log('Not in a meeting - audio streaming will start when you join a meeting');
        streamingStatus.value = 'Connected to server (waiting for meeting)';
      }
    };

    serverWebSocket.onmessage = (event) => {
      const message = JSON.parse(event.data);
      // Only log error messages or important status updates
      if (message.type === 'error') {
        console.error('Server error:', message);
      } else if (message.type === 'connection') {
        console.log('Server connection:', message.message);
      }
      // Don't log every audio_received message to reduce console spam
    };

    serverWebSocket.onclose = () => {
      console.log('Disconnected from audio server');
      isStreamingToServer.value = false;
      streamingStatus.value = 'Disconnected from server';
    };

    serverWebSocket.onerror = (error) => {
      console.error('WebSocket error:', error);
      isStreamingToServer.value = false;
      streamingStatus.value = 'Connection error';
    };

  } catch (error) {
    console.error('Error connecting to server:', error);
    streamingStatus.value = 'Connection failed';
  }
}

function stopStreamingToServer() {
  if (serverWebSocket) {
    serverWebSocket.close();
    serverWebSocket = null;
  }
  isStreamingToServer.value = false;
  streamingStatus.value = 'Not streaming';
}

function stopAudioStreamProcessing() {
  console.log('Stopping audio stream processing...');

  // Stop all audio stream processors
  for (const [streamId, processor] of audioStreamProcessors.entries()) {
    console.log(`Stopping audio processing for ${streamId}`);
    
    // Clean up ScriptProcessorNode resources
    if (processor.audioProcessor) {
      processor.audioProcessor.disconnect();
    }
    
    if (processor.source) {
      processor.source.disconnect();
    }
    
    if (processor.audioContext) {
      processor.audioContext.close();
    }
  }
  
  // Clear all processors
  audioStreamProcessors.clear();

  stopStreamingToServer();
  streamingStatus.value = 'Stopped';
}

// Login/Logout button click handler
function loginButtonClick() {
  console.log('Login/Logout button clicked!');
  console.log('isLoggedIn.value:', isLoggedIn.value);
  
  if (isLoggedIn.value) {
    console.log('Calling logout...');
    logout();
  } else {
    console.log('Calling login...');
    login();
  }
}

// Join/Leave Meeting button click handler
async function joinLeaveButtonClick() {
  console.log('Join/Leave Meeting button clicked!');
  console.log('sessionStatus.value:', sessionStatus.value);
  console.log('canJoinMeeting.value:', canJoinMeeting.value);
  
  try {
  if (sessionStatus.value === 'JOINED') {
    console.log('Calling leaveMeeting...');
    await leaveMeeting();
  } else {
    console.log('Calling joinMeeting...');
    await joinMeeting();
    }
  } catch (error: any) {
    console.error('Error in joinLeaveButtonClick:', error);
    // Don't re-throw the error - it's already handled in joinMeeting/leaveMeeting
    // Just log it and let the UI handle the error state
  }
}

// Google OAuth login
function login() {
  console.log('Login function called!');
  console.log('clientId.value:', clientId.value);
  
  if (!clientId.value) {
    alert("Please input a google cloud client id before logging in");
    return;
  }

  console.log('About to load Google OAuth script...');
  
  // Load Google OAuth script if not already loaded
  if (!(window as any).google) {
    console.log('Google script not loaded, loading it now...');
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.onload = () => {
      console.log('Google script loaded, calling performLogin...');
      performLogin();
    };
    script.onerror = (error) => {
      console.error('Failed to load Google script:', error);
    };
    document.head.appendChild(script);
  } else {
    console.log('Google script already loaded, calling performLogin...');
    performLogin();
  }
}

function performLogin() {
  console.log('performLogin function called!');
  console.log('window.google exists:', !!(window as any).google);
  console.log('window.google.accounts exists:', !!(window as any).google?.accounts);
  console.log('window.google.accounts.oauth2 exists:', !!(window as any).google?.accounts?.oauth2);
  
  try {
    const googleClient = (window as any).google.accounts.oauth2.initTokenClient({
      client_id: clientId.value,
      scope: 'https://www.googleapis.com/auth/meetings.space.created https://www.googleapis.com/auth/meetings.conference.media.readonly https://www.googleapis.com/auth/meetings.space.readonly https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/userinfo.email',
      callback: (response: any) => {
        console.log('OAuth callback triggered!');
        console.log('response');
        console.log(response);
        console.log('Full scope string:', response.scope);
        console.log('Scope length:', response.scope?.length);
        tokenResponse.value = response;
        
        // Get user info and set default participants
        getUserInfoAndSetDefaults(response.access_token);
        
        console.log('Login successful!');
      },
      error_callback: (errorResponse: any) => {
        console.log('OAuth error callback triggered!');
        console.log('error');
        console.log(errorResponse);
        alert('Login failed: ' + JSON.stringify(errorResponse));
      },
    });
    
    console.log('Google client created, requesting access token...');
    googleClient.requestAccessToken();
    console.log('requestAccessToken called');
  } catch (error) {
    console.error('Error in performLogin:', error);
    alert('Error initializing Google OAuth: ' + error);
  }
}

async function getUserInfoAndSetDefaults(accessToken: string) {
  console.log('Getting user info with access token:', accessToken ? 'Token exists' : 'No token');
  
  try {
    const response = await fetch('https://www.googleapis.com/oauth2/v2/userinfo', {
      headers: {
        'Authorization': `Bearer ${accessToken}`
      }
    });
    
    console.log('Userinfo API response status:', response.status);
    
    if (response.ok) {
      const userInfo = await response.json();
      console.log('User info received:', userInfo);
      const userEmail = userInfo.email;
      
      if (userEmail) {
        // Set current user email for display
        currentUserEmail.value = userEmail;
        // Set default participants based on user's email
        setDefaultParticipants(userEmail);
      } else {
        console.error('No email found in user info');
      }
    } else {
      const errorText = await response.text();
      console.error('Userinfo API error:', response.status, errorText);
    }
  } catch (error) {
    console.error('Error getting user info:', error);
  }
}

function setDefaultParticipants(userEmail: string) {
  console.log('Setting default participants for email:', userEmail);
  
  // Create the second email by replacing @ituri.ai with @devicepros.net
  const secondEmail = userEmail.replace('@ituri.ai', '@devicepros.net');
  
  defaultParticipants.value = [userEmail, secondEmail];
  
  console.log('Default participants set:', defaultParticipants.value);
  console.log('defaultParticipants.value length:', defaultParticipants.value.length);
}

function copyMeetingLink() {
  const meetingLink = `https://meet.google.com/${meetingCode.value}`;
  navigator.clipboard.writeText(meetingLink).then(() => {
    console.log('Meeting link copied to clipboard!');
  }).catch((err) => {
    console.error('Failed to copy meeting link:', err);
    alert('Failed to copy meeting link');
  });
}

function handleMeetingCodePaste(event: ClipboardEvent) {
  // Get the pasted text
  const pastedText = event.clipboardData?.getData('text') || '';
  
  // Check if it's a Google Meet URL and extract the meeting code
  const meetUrlPattern = /https?:\/\/meet\.google\.com\/([a-z-]+)/i;
  const match = pastedText.match(meetUrlPattern);
  
  if (match && match[1]) {
    // Extract the meeting code from the URL
    const extractedCode = match[1];
    
    // Prevent the default paste behavior
    event.preventDefault();
    
    // Set the meeting code to the extracted value
    meetingCode.value = extractedCode;
    
    console.log(`Extracted meeting code from URL: ${extractedCode}`);
  }
  // If it's not a URL, let the default paste behavior continue
}

function resetDisconnectionState() {
  console.log('Forcing disconnection state to complete...');
  disconnectionComplete.value = true;
  console.log('Disconnection state reset - can rejoin now');
}

function testAudioProcessing() {
  console.log('=== Testing Audio Processing ===');
  
  // Check if we have any audio streams
  const audioElements = document.querySelectorAll('audio[id^="audio-"]');
  console.log(`Found ${audioElements.length} audio elements`);
  
  if (audioElements.length === 0) {
    console.log('No audio elements found - no meeting streams to test');
    console.log('Continuing with other audio tests...');
  } else {
    console.log('Found meeting audio streams - testing them...');
  }
  
  // Test each audio element (only if we have meeting streams)
  if (audioElements.length > 0) {
    for (let i = 0; i < audioElements.length; i++) {
      const audioElement = audioElements[i] as HTMLAudioElement;
      const streamId = audioElement.id;
      
      console.log(`\n--- Testing ${streamId} ---`);
      console.log('Element properties:', {
        srcObject: !!audioElement.srcObject,
        paused: audioElement.paused,
        muted: audioElement.muted,
        volume: audioElement.volume,
        readyState: audioElement.readyState,
        networkState: audioElement.networkState
      });
      
      if (audioElement.srcObject) {
        const mediaStream = audioElement.srcObject as MediaStream;
        const audioTracks = mediaStream.getAudioTracks();
        console.log(`Audio tracks: ${audioTracks.length}`);
        
        for (const track of audioTracks) {
          console.log('Track details:', {
            id: track.id,
            enabled: track.enabled,
            muted: track.muted,
            readyState: track.readyState,
            kind: track.kind
          });
        }
      }
      
      // Check if we have a processor for this stream
      if (audioStreamProcessors.has(streamId)) {
        const processor = audioStreamProcessors.get(streamId)!;
        console.log('Processor details:', {
          contextState: processor.audioContext?.state || 'undefined',
          sampleRate: processor.audioContext?.sampleRate || 'undefined',
          hasProcessor: !!processor.audioProcessor,
          hasSource: !!processor.source
        });
      } else {
        console.log('No processor found for this stream');
      }
    }
  }
  
  // Generate a test tone to verify audio processing works
  console.log('\n--- Generating Test Tone ---');
  try {
    const testContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    const oscillator = testContext.createOscillator();
    const gainNode = testContext.createGain();
    
    oscillator.connect(gainNode);
    gainNode.connect(testContext.destination);
    
    oscillator.frequency.setValueAtTime(440, testContext.currentTime); // A4 note
    gainNode.gain.setValueAtTime(0.1, testContext.currentTime); // Low volume
    
    oscillator.start(testContext.currentTime);
    oscillator.stop(testContext.currentTime + 0.5); // Play for 0.5 seconds
    
    console.log('[TEST_TONE] Test tone generated successfully');
    
    // Clean up after test
    setTimeout(() => {
      testContext.close();
      console.log('[TEST_TONE] Test tone cleanup completed');
    }, 1000);
    
  } catch (error) {
    console.error('[TEST_TONE] Error generating test tone:', error);
  }
  
  // Test if audio processing callback mechanism works
  console.log('\n--- Testing Audio Processing Callback ---');
  try {
    const testContext = new (window.AudioContext || (window as any).webkitAudioContext)();
    const oscillator = testContext.createOscillator();
    const gainNode = testContext.createGain();
    const processor = testContext.createScriptProcessor(4096, 1, 1);
    
    let callbackCount = 0;
    processor.onaudioprocess = (event) => {
      callbackCount++;
      if (callbackCount <= 5) {
        console.log(`[TEST_CALLBACK] Audio processing callback ${callbackCount} triggered`);
      }
    };
    
    oscillator.connect(gainNode);
    gainNode.connect(processor);
    processor.connect(testContext.destination);
    
    oscillator.frequency.setValueAtTime(440, testContext.currentTime);
    gainNode.gain.setValueAtTime(0.1, testContext.currentTime);
    
    oscillator.start(testContext.currentTime);
    oscillator.stop(testContext.currentTime + 1); // Play for 1 second
    
    console.log('Audio processing callback test started');
    
    // Check callback count after a delay
    setTimeout(() => {
      console.log(`[TEST_CALLBACK] Total callbacks triggered: ${callbackCount}`);
      testContext.close();
    }, 1500);
    
  } catch (error) {
    console.error('Error testing audio processing callback:', error);
  }
  
    try {
      navigator.mediaDevices.getUserMedia({ audio: true })
        .then(stream => {
          console.log('[TEST_MIC] Microphone access granted');
          console.log('[TEST_MIC] Stream tracks:', stream.getTracks().map(track => ({
            id: track.id,
            enabled: track.enabled,
            muted: track.muted,
            readyState: track.readyState,
            kind: track.kind,
            label: track.label
          })));
          
          // Test processing microphone audio
          const micContext = new (window.AudioContext || (window as any).webkitAudioContext)();
          const micSource = micContext.createMediaStreamSource(stream);
          const micProcessor = micContext.createScriptProcessor(4096, 1, 1);
          
          let micCallbackCount = 0;
          micProcessor.onaudioprocess = (event) => {
            micCallbackCount++;
            if (micCallbackCount <= 3) {
              const inputData = event.inputBuffer.getChannelData(0);
              const firstSamples = [];
              for (let i = 0; i < Math.min(5, inputData.length); i++) {
                firstSamples.push(inputData[i].toFixed(6));
              }
              console.log(`[TEST_MIC] Callback ${micCallbackCount}, first 5 samples:`, firstSamples);
            }
          };
          
          micSource.connect(micProcessor);
          micProcessor.connect(micContext.destination);
          
          console.log('[TEST_MIC] Microphone audio processing started - speak to test');
          
          // Stop after 3 seconds
          setTimeout(() => {
            console.log(`[TEST_MIC] Total microphone callbacks: ${micCallbackCount}`);
            stream.getTracks().forEach(track => track.stop());
            micContext.close();
          }, 3000);
          
        })
        .catch(error => {
          console.error('[TEST_MIC] Microphone access denied:', error);
        });
    } catch (error) {
      console.error('[TEST_MIC] Error testing microphone:', error);
    }
}




function logout() {
  // Clear all authentication data
  tokenResponse.value = null;
  currentUserEmail.value = '';
  defaultParticipants.value = [];
  
  // Clear any existing client
  if (client.value) {
    client.value.leaveMeeting();
    client.value = null;
  }
  
  // Reset session status
  sessionStatus.value = 'New';
  
  // Stop any audio processing
  stopAudioStreamProcessing();
  
  // Reset all connection states
  disconnectionComplete.value = true;
  
  console.log('Logged out successfully');
}

onMounted(() => {
  // Initialize any necessary setup
  console.log('MeetingMenu component mounted');
  
  // Initialize disconnection state - allow joining if not currently in a meeting
  disconnectionComplete.value = true;
  
  // Initialize participant list display
  participantsList.value = '<div class="participant-item">Not connected to any meeting</div>';
  

});

onUnmounted(() => {
  // Cleanup
  stopAudioStreamProcessing();
  if (client.value) {
    client.value.leaveMeeting();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
        class: "close-button"
      }, "×")
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _withDirectives(_createElementVNode("input", {
            id: "client-id",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((clientId).value = $event)),
            type: "text",
            placeholder: "Enter Google Cloud Client ID"
          }, null, 512), [
            [_vModelText, clientId.value]
          ])
        ]),
        _createElementVNode("button", {
          onClick: loginButtonClick,
          class: _normalizeClass(["btn", isLoggedIn.value ? 'btn-secondary' : 'btn-primary'])
        }, _toDisplayString(isLoggedIn.value ? `Logout ${currentUserEmail.value}` : 'Login with Google'), 3),
        (currentUserEmail.value && !currentUserEmail.value.includes('@ituri.ai'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("p", null, [
                _createTextVNode("You are currently logged in with: "),
                _createElementVNode("strong", null, _toDisplayString(currentUserEmail.value), 1)
              ]),
              _hoisted_11,
              _hoisted_12
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("span", {
            class: _normalizeClass(["status-indicator", { active: isLoggedIn.value }])
          }, " 🔐 " + _toDisplayString(isLoggedIn.value ? 'Logged In' : 'Not Logged In'), 3),
          _createElementVNode("span", {
            class: _normalizeClass(["status-indicator", { active: hasMeetingCode.value }])
          }, " 📝 " + _toDisplayString(hasMeetingCode.value ? 'Meeting Code Set' : 'No Meeting Code'), 3),
          _createElementVNode("span", {
            class: _normalizeClass(["status-indicator", { active: client.value }])
          }, " 🔗 " + _toDisplayString(client.value ? 'Client Connected' : 'No Client'), 3),
          (!disconnectionComplete.value && isLoggedIn.value && hasMeetingCode.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["status-indicator", { active: disconnectionComplete.value }])
              }, " ⏳ Waiting for Disconnect ", 2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              id: "meeting-code",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((meetingCode).value = $event)),
              type: "text",
              placeholder: "Enter meeting code or paste full meeting URL",
              onPaste: handleMeetingCodePaste
            }, null, 544), [
              [_vModelText, meetingCode.value]
            ]),
            _createElementVNode("button", {
              onClick: createSpace,
              class: "btn btn-secondary",
              disabled: !canCreateSpace.value
            }, "Create New", 8, _hoisted_19)
          ])
        ]),
        (meetingCode.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("a", {
                  href: `https://meet.google.com/${meetingCode.value}`,
                  target: "_blank",
                  class: "meeting-link-text"
                }, " https://meet.google.com/" + _toDisplayString(meetingCode.value), 9, _hoisted_23),
                _createElementVNode("button", {
                  onClick: copyMeetingLink,
                  class: "btn btn-secondary copy-btn"
                }, "Copy")
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("label", _hoisted_25, "Number of video streams: " + _toDisplayString(videoStreamCount.value), 1),
          _withDirectives(_createElementVNode("input", {
            id: "video-stream",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((videoStreamCount).value = $event)),
            type: "range",
            min: "0",
            max: "3",
            class: "range-input"
          }, null, 512), [
            [_vModelText, videoStreamCount.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              id: "audio-stream",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((enableAudio).value = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, enableAudio.value]
            ]),
            _createTextVNode(" Enable Audio ")
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            onClick: joinLeaveButtonClick,
            class: _normalizeClass(["btn", sessionStatus.value === 'JOINED' ? 'btn-danger' : 'btn-primary']),
            disabled: sessionStatus.value === 'JOINED' ? isLeavingMeeting.value : !canJoinMeeting.value
          }, _toDisplayString(sessionStatus.value === 'JOINED' ? (isLeavingMeeting.value ? 'Leaving...' : 'Leave Meeting') : (disconnectionComplete.value ? 'Join Meeting' : 'Waiting for disconnect...')), 11, _hoisted_28),
          _createElementVNode("span", _hoisted_29, "Session Status: " + _toDisplayString(sessionStatus.value), 1)
        ]),
        (!canJoinMeeting.value && sessionStatus.value !== 'JOINED')
          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("small", null, [
                _createTextVNode(" 💡 "),
                _hoisted_31,
                _createTextVNode(" requires: "),
                (!isLoggedIn.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, "Login with Google"))
                  : _createCommentVNode("", true),
                (!isLoggedIn.value && !hasMeetingCode.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_33, " and "))
                  : _createCommentVNode("", true),
                (!hasMeetingCode.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, "Meeting Code"))
                  : _createCommentVNode("", true),
                (!client.value && isLoggedIn.value && hasMeetingCode.value && disconnectionComplete.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_35, " (Client will be created automatically)"))
                  : _createCommentVNode("", true),
                (!disconnectionComplete.value && isLoggedIn.value && hasMeetingCode.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_36, " (Waiting for previous connection to fully disconnect)"))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_37, [
        _hoisted_38,
        _createElementVNode("button", {
          onClick: refreshParticipants,
          class: "btn btn-secondary",
          disabled: !client.value
        }, "Refresh Participants", 8, _hoisted_39),
        _createElementVNode("button", {
          onClick: refreshParticipantMapping,
          class: "btn btn-secondary",
          disabled: !client.value
        }, "Refresh Audio Mapping", 8, _hoisted_40),
        _createElementVNode("button", {
          onClick: testApiConnectivity,
          class: "btn btn-secondary",
          disabled: !isLoggedIn.value
        }, "Test API Connectivity", 8, _hoisted_41),
        _createElementVNode("button", {
          onClick: resetDisconnectionState,
          class: "btn btn-secondary",
          disabled: disconnectionComplete.value
        }, "Force Allow Rejoin", 8, _hoisted_42),
        _createElementVNode("button", {
          onClick: testAudioProcessing,
          class: "btn btn-secondary"
        }, "Test Audio Processing")
      ]),
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _hoisted_45,
        _createElementVNode("div", _hoisted_46, [
          _hoisted_47,
          _withDirectives(_createElementVNode("input", {
            id: "server-url",
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((serverUrl).value = $event)),
            type: "text",
            placeholder: "ws://localhost:8081"
          }, null, 512), [
            [_vModelText, serverUrl.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("button", {
            onClick: startStreamingToServer,
            class: "btn btn-success",
            disabled: !canStartStreaming.value
          }, " Start Streaming ", 8, _hoisted_49),
          _createElementVNode("button", {
            onClick: stopStreamingToServer,
            class: "btn btn-danger",
            disabled: !canStopStreaming.value
          }, " Stop Streaming ", 8, _hoisted_50)
        ]),
        _createElementVNode("p", _hoisted_51, "Streaming Status: " + _toDisplayString(streamingStatus.value), 1),
        _hoisted_52
      ]),
      _createElementVNode("div", _hoisted_53, [
        _hoisted_54,
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _withDirectives(_createElementVNode("input", {
            id: "participant-email",
            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((participantEmail).value = $event)),
            type: "email",
            placeholder: "Enter email address"
          }, null, 512), [
            [_vModelText, participantEmail.value]
          ])
        ]),
        _createElementVNode("button", {
          onClick: inviteParticipant,
          class: "btn btn-primary",
          disabled: !canInviteParticipant.value
        }, "Invite Participant", 8, _hoisted_57),
        _hoisted_58,
        (defaultParticipants.value.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
              _hoisted_60,
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(defaultParticipants.value, (participant) => {
                  return (_openBlock(), _createElementBlock("li", { key: participant }, _toDisplayString(participant), 1))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_61, _hoisted_63)),
        _hoisted_64,
        _createElementVNode("div", {
          class: "participants-list",
          innerHTML: participantsList.value
        }, null, 8, _hoisted_65)
      ]),
      (spaceResult.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
            _hoisted_67,
            _createElementVNode("pre", _hoisted_68, _toDisplayString(spaceResult.value), 1)
          ]))
        : _createCommentVNode("", true),
      _hoisted_69
    ])
  ]))
}
}

})